import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getPermissionsTransform from '../helpers/getPermissionsTransform';
import handleVideoUnauthorizedError from '../helpers/handleVideoUnauthorizedError';

export default ({ isTopicsRoute, videoVersion, editorPermissions }) => {
  const { id, type, tabId, orgId } = useParams();

  const isInLiveMode = type === 'live';
  const permissionableId = (!isTopicsRoute && isInLiveMode && videoVersion.data?.video_id) || id;

  const permissionsKey = useMemo(() => ['permissions', id], [id]);
  const permissions = useQuery(
    permissionsKey,
    async () => {
      try {
        const { data } = await axios(
          getAxiosConfig('get-videos-admin-permissions', { id, permissionableId, isInLiveMode }),
        );
        return getPermissionsTransform({ data, editorPermissions });
      } catch (error) {
        handleVideoUnauthorizedError({
          error,
          orgId,
          type,
          conditionedQueryCache: editorPermissions,
        });
        return {};
      }
    },
    {
      enabled:
        (tabId === 'topic-permissions' || tabId === 'video-permissions') &&
        editorPermissions.status === 'success' &&
        (type === 'on-demand' || videoVersion.data?.video_id !== undefined),
    },
  );

  return { permissionsKey, permissions };
};
